"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogBrowserSelectorItem = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
// Styles from Vizportal "Spaces Explorer"
const ItemContainer = (0, vizportalclient_common_components_1.divWithStyle)('ItemContainer', Object.assign(Object.assign({}, data_catalog_shared_1.flexRowStyle), { justifyContent: 'space-between', whiteSpace: 'nowrap', padding: '6px 0', fontFamily: data_catalog_shared_1.vizPortalFontStyle.fontFamily }));
const CountLabel = (0, vizportalclient_common_components_1.divWithStyle)('CountLabel', {
    minWidth: 36,
    marginLeft: widgets_1.TabStyles.Spacing.MediumSpace,
    textAlign: 'right',
    color: widgets_1.TabStyles.Typography.Color.Disabled,
});
function CatalogBrowserSelectorItem(props) {
    return (react_1.default.createElement(ItemContainer, { "data-tb-test-id": 'catalog-browser-selector' },
        react_1.default.createElement("div", null, props.subplaceName),
        react_1.default.createElement(CountLabel, null, props.count ? catalog_messages_1.Formatters.formatCount(props.count) : null)));
}
exports.CatalogBrowserSelectorItem = CatalogBrowserSelectorItem;
//# sourceMappingURL=CatalogBrowserSelectorItem.js.map